export default __webpack_public_path__ + "static/media/Helm of Unrest.8e0b79ad.jpg";